// extracted by mini-css-extract-plugin
export default {"root":"Header_root__m7YHL","logo":"Header_logo__ZdnYX","menuContainer":"Header_menuContainer__RTBNt","menu":"Header_menu__q02Ye","link":"Header_link__P5nTA"};